import { render, staticRenderFns } from "./CategoryBanners.vue?vue&type=template&id=6a4af05d&scoped=true&"
import script from "./CategoryBanners.vue?vue&type=script&lang=js&"
export * from "./CategoryBanners.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBanners.vue?vue&type=style&index=0&id=6a4af05d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4af05d",
  null
  
)

export default component.exports